import React, { useEffect, useState } from "react";
import "./main.css";

const Main = (props: React.PropsWithChildren<{}>) => {
  const [hasHeader, setHasHeader] = useState(false);

  useEffect(() => {
    const hideParam = new URL(document.location.href).searchParams.get(
      "hide-header"
    );
    setHasHeader(hideParam ? false : true);
  }, []);

  return (
    <div
      className="main-wrapper"
      style={{ minHeight: hasHeader ? "40vh" : "80vh" }}
    >
      <div className="main-container">{props.children}</div>
    </div>
  );
};

export default Main;
